import { ORGANIZATIONS_API, ORGANIZATION_EMAILS_API } from "../../../Utilities/APIs";
import PcBESCRUD from "../../Partials/Layouts/CRUDs/CRUDLayouts/BESCRUD/PcBESCRUD";

function PcOrganizationEmails() {
  return (
    <PcBESCRUD
        // parentChild props
        parentDBField={'organization'}
        
        // common props
        api={ORGANIZATION_EMAILS_API}
        screenTopicSingular={'Organization Email'}
        screenTopicPlural={'Organization Emails'}
        
        // crud header props
        showTotalInHeading
        
        // crud props
        allowCreate
        allowUpdate
        allowDelete

        //boolean props
        booleanDBField={'isVisible'}
        booleanName={'Is Visible'}
        
        // select props
        selectApi={ORGANIZATIONS_API}
        selectType={'parent-child'}
        selectDBField={'organization'}
        selectName={'Organization'}
    />
  )
}

export default PcOrganizationEmails